import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppsContent from '@nxsys/components/AppsContainer/AppsContent';
import AppTableContainer from '@nxsys/components/AppTableContainer';
import { ColumnsType } from 'antd/lib/table';
import { IMPORT_COLUMNS_WIDTH } from '../../import/constants';
import React, { useEffect, useMemo, useState } from 'react';
import * as XLSX from 'xlsx';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  url: string;
};

const ViewDetailAgencyFileModal: React.FC<Props> = ({ isOpen, toggle, url }) => {
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState<string[][]>([]);

  const [columns, rowsData] = useMemo(() => {
    if (!excelData.length) {
      return [[], []];
    }
    const headers = excelData[0] as string[] || [];
    const columns = headers.map((h: string, index: number) => ({
      key: index,
      title: h,
      align: 'left',
      dataIndex: 'row',
      render: (rowData: string[]) => (
        <span className={`mb-0`}>{rowData?.[index] || '_'}</span>
      ),
      width: IMPORT_COLUMNS_WIDTH?.[
        h as keyof typeof IMPORT_COLUMNS_WIDTH
      ] ?? 200,
    }));
    const data = excelData.slice(1).map((row, index) => ({ id: index, row }));
    return [columns, data];
  }, [excelData]);

  const handleFetchFromUrl = async () => {
    try {
      setLoading(true);
      const response = await fetch(url);
      const data = await response.arrayBuffer();
      const workbook = XLSX.read(data, { type: 'array' });
      const sheet = workbook.Sheets['Sheet1'];
      const jsonData = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        blankrows: false,
      });
      setExcelData(Object.values(jsonData || {}) as string[][]);
    } catch (error) {
      console.error('Error fetching or parsing Excel file:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!!url && isOpen) {
      handleFetchFromUrl();
    }
    if (!isOpen) {
      setExcelData([]);
    }
  }, [url, isOpen]);

  return (
    <AppModalContainer
      title="View Files"
      isOpen={isOpen}
      toggle={toggle}
      hiddenFooter
      className="max-sm:w-[100vw]"
      width={1200}
      minHeight="0"
    >
      <AppsContent>
        <AppTableContainer
          rowKey="id"
          data={rowsData}
          loading={loading}
          pagination={false}
          page={1}
          total={rowsData.length ?? 0}
          pageSize={rowsData.length ?? 0}
          scroll={{ x: 10000 }}
          columns={columns as ColumnsType<{ id: number; row: string[] }>}
        />
      </AppsContent>
    </AppModalContainer>
  );
};

export default ViewDetailAgencyFileModal;
